import { render, staticRenderFns } from "./LocalePicker.vue?vue&type=template&id=7bdc4212&scoped=true"
import script from "./LocalePicker.vue?vue&type=script&lang=js"
export * from "./LocalePicker.vue?vue&type=script&lang=js"
import style0 from "./LocalePicker.vue?vue&type=style&index=0&id=7bdc4212&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdc4212",
  null
  
)

export default component.exports